import styled from 'styled-components'
import { FaArrowRight } from 'react-icons/fa'

export const Arrow = styled(FaArrowRight)`
  font-size: 1.5rem;
  color: rgb(255, 255, 255, 0.7);
`;

export const StyledButton = styled.button`
  background-color: ${(props) => props.color};
  color: ${({ theme }) => theme.palette.grayscale[8]};
  font-size: 1.1rem;
  font-weight: 500;
  height: 4rem;
  margin-top: 0.5rem;
  margin-bottom: 0.8rem;
  line-height: 3rem;
  position: relative;
  padding-left: 1rem;
  cursor: pointer;
  width: 100%;
  text-align: left;
  border: 0;

  svg {
    position: absolute;
    right: 1rem;
    top: 25%;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  
  &:focus {
    outline: none;
  }
`;
